import { render, staticRenderFns } from "./investment-details.vue?vue&type=template&id=575d874c&scoped=true"
import script from "./investment-details.vue?vue&type=script&lang=js"
export * from "./investment-details.vue?vue&type=script&lang=js"
import style0 from "./investment-details.vue?vue&type=style&index=0&id=575d874c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d874c",
  null
  
)

export default component.exports